// extracted by mini-css-extract-plugin
export default {"modalFooterButtons":"ShippingFormVariantEditionModal_modalFooterButtons__FcC7Y"};